// extracted by mini-css-extract-plugin
export var change = "_3p-1";
export var changeList = "_3p-0";
export var changePath = "_3p-2";
export var diffArrow = "_3p-5";
export var diffRow = "_3p-3";
export var diffValue = "_3p-4";
export var error = "_3p-8";
export var notice = "_3p-9";
export var result = "_3p-6";
export var success = "_3p-7";